import PageSettings from './PageSettings';

export default PageSettings;
